<template>
    <div class="DictForm">
        <div class="flex row-left-center mb-2">
            <div class="flex-1">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('entities.dicts.create.key.label') }}
                </WText>
                <WFieldError
                    :validator="$v.form.key"
                    :label="$t('entities.dicts.create.key.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="form.key"
                        :error="errorMessage"
                        :placeholder="$t('entities.dicts.create.key.placeholder')"
                        :disabled="isLoading"
                        name="key"
                        type="text"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>

            <div class="flex-1 ml-1">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('entities.dicts.create.name.label') }}
                </WText>
                <WFieldError
                    :validator="$v.form.name"
                    :label="$t('entities.dicts.create.name.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="form.name"
                        :error="errorMessage"
                        :placeholder="$t('entities.dicts.create.name.placeholder')"
                        :disabled="isLoading"
                        name="name"
                        type="text"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>
        </div>

        <div class="flex row-right-center">
            <WButton
                outline
                color="accent-blue"
                :loading="isLoading"
                @click="$emit('onReset')"
            >
                {{ $t('entities.creation.reset') }}
            </WButton>
            <WButton
                color="primary"
                :loading="isLoading"
                :disabled="isLoading"
                class="ml-2"
                @click="handleSubmit"
            >
                {{ $t('entities.dicts.create.submit') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { Api, apiRequest } from '@/api'

export default {
    name: 'DictForm',
    mixins: [validationMixin],
    props: {
        value: VueTypes.shape({
            key: VueTypes.string,
            name: VueTypes.string,
        }).def({}).loose,
    },
    data () {
        return {
            form: {
                entries: undefined,
                key: '',
                name: '',
                ...this.value,
            },
            dictKey: (this.value || {}).key,
            isLoading: false,
        }
    },
    validations () {
        return {
            form: {
                key: { required },
                name: { required },
            },
        }
    },
    methods: {
        handleSubmit () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                if ((this.form || {}).entries !== undefined) this.updateDict()
                else this.createDict()
            }
        },
        async createDict () {
            this.isLoading = true
            const { key, name } = this.form
            const params = { key, name }
            apiRequest(Api().dictionaries.create(params))
                .then(() => this.$emit('onSubmit', params))
                .catch(() => this.$emit('onError'))
                .finally(() => (this.isLoading = false))
        },
        async updateDict () {
            this.isLoading = true
            const { key, name } = this.form
            const params = { key, name }
            apiRequest(Api().dictionaries.edit({ dictKey: this.dictKey, params }))
                .then(() => this.$emit('onSubmit', params))
                .catch(() => this.$emit('onError'))
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
